import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { getPersonStatusLabel } from "../utils/personProposalOrigin";
export var useLegalPersonTable = function (onRowClick) {
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var handleNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.legal-person.table.columns.name",
            }),
            key: "name",
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.legal-person.table.columns.residence",
            }),
            key: "residence",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.legal-person.table.columns.status",
            }),
            key: "status",
            // A proposal names its origin (DB-899), other statuses stay as they are.
            cellRenderer: function (item) { return getPersonStatusLabel(intl, item); },
        },
    ]; }, [formatMessage, intl, handleNameClick]);
    return {
        columns: columns,
    };
};
